import ArtistsList from './artistslist'

export default ArtistsList
